import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon, InfoIcon, ExternalLinkIcon } from 'lucide-react';
export function VampDetail() {
  const navigate = useNavigate();
  const [showFraudTooltip, setShowFraudTooltip] = useState(false);
  const [showCardTestingTooltip, setShowCardTestingTooltip] = useState(false);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return <div className="max-w-7xl mx-auto" data-id="element-11963">
      {/* Breadcrumb */}
      <div className="mb-6" data-id="element-11964">
        <button onClick={() => navigate('/card-monitoring')} className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-11965">
          <ChevronLeftIcon size={16} data-id="element-11966" />
          <span data-id="element-11967">Card monitoring programs</span>
        </button>
      </div>

      {/* Header */}
      <div className="mb-8" data-id="element-11968">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-11969">
          Visa Acquirer Monitoring Program (VAMP)
        </h1>
        <p className="text-gray-600" data-id="element-11970">
          View your monitoring program status and history.
        </p>
      </div>

      {/* History Section */}
      <div className="mb-12" data-id="element-11971">
        <div className="flex items-center gap-2 mb-2" data-id="element-11972">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-11973">History</h2>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-11974">
            <InfoIcon size={16} data-id="element-11975" />
          </button>
        </div>
        <p className="text-sm text-gray-600 mb-6" data-id="element-11976">
          Your program history for the last 12 months.
        </p>

        {/* History Table */}
        <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-11977">
          <table className="w-full" data-id="element-11978">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-11979">
              <tr data-id="element-11980">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-11981">
                  Program type
                </th>
                {months.map(month => <th key={month} className="px-4 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-11982">
                    {month}
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-11983">
              {/* Fraud and disputes row */}
              <tr className="hover:bg-gray-50" data-id="element-11984">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-11985">
                  <div className="flex items-center gap-2" data-id="element-11986">
                    <span className="text-sm text-gray-900" data-id="element-11987">
                      Fraud and disputes
                    </span>
                    <div className="relative" data-id="element-11988">
                      <button onMouseEnter={() => setShowFraudTooltip(true)} onMouseLeave={() => setShowFraudTooltip(false)} className="text-gray-400 hover:text-gray-600" data-id="element-11989">
                        <InfoIcon size={14} data-id="element-11990" />
                      </button>
                      {showFraudTooltip && <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 z-10 w-64 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-lg whitespace-normal" data-id="element-11991">
                          Measures fraud and disputes against the total number
                          of settled payments
                          <div className="absolute right-full top-1/2 -translate-y-1/2 border-8 border-transparent border-r-gray-900" data-id="element-11992"></div>
                        </div>}
                    </div>
                  </div>
                </td>
                {months.map((month, index) => <td key={month} className="px-4 py-4 text-center" data-id="element-11993">
                    {index === 11 ? <div className="flex justify-center" data-id="element-11994">
                        <div className="animate-spin h-4 w-4 border-2 border-gray-300 border-t-blue-600 rounded-full" data-id="element-11995"></div>
                      </div> : <div className="flex justify-center" data-id="element-11996">
                        <div className="w-3 h-3 bg-gray-300 rounded-full" data-id="element-11997"></div>
                      </div>}
                  </td>)}
              </tr>

              {/* Card testing row */}
              <tr className="hover:bg-gray-50" data-id="element-11998">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-11999">
                  <div className="flex items-center gap-2" data-id="element-12000">
                    <span className="text-sm text-gray-900" data-id="element-12001">Card testing</span>
                    <div className="relative" data-id="element-12002">
                      <button onMouseEnter={() => setShowCardTestingTooltip(true)} onMouseLeave={() => setShowCardTestingTooltip(false)} className="text-gray-400 hover:text-gray-600" data-id="element-12003">
                        <InfoIcon size={14} data-id="element-12004" />
                      </button>
                      {showCardTestingTooltip && <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 z-10 w-64 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-lg whitespace-normal" data-id="element-12005">
                          Measures card testing against the total number of
                          settled payments
                          <div className="absolute right-full top-1/2 -translate-y-1/2 border-8 border-transparent border-r-gray-900" data-id="element-12006"></div>
                        </div>}
                    </div>
                  </div>
                </td>
                {months.map((month, index) => <td key={month} className="px-4 py-4 text-center" data-id="element-12007">
                    {index === 11 ? <div className="flex justify-center" data-id="element-12008">
                        <div className="animate-spin h-4 w-4 border-2 border-gray-300 border-t-blue-600 rounded-full" data-id="element-12009"></div>
                      </div> : <div className="flex justify-center" data-id="element-12010">
                        <div className="w-3 h-3 bg-gray-300 rounded-full" data-id="element-12011"></div>
                      </div>}
                  </td>)}
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Historical and current program status */}
      <div className="mb-12" data-id="element-12012">
        <div className="flex items-center gap-2 mb-2" data-id="element-12013">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-12014">
            Historical and current program status
          </h2>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-12015">
            <InfoIcon size={16} data-id="element-12016" />
          </button>
        </div>
        <p className="text-sm text-gray-600 mb-6" data-id="element-12017">
          Visa-identified fraud and disputes against the total number of settled
          payments
        </p>

        <div className="bg-white border border-gray-200 rounded-lg p-8" data-id="element-12018">
          <p className="text-center text-gray-500" data-id="element-12019">No past history found.</p>
        </div>
      </div>

      {/* Estimated program status */}
      <div className="mb-12" data-id="element-12020">
        <div className="flex items-center gap-2 mb-2" data-id="element-12021">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-12022">
            Estimated program status
          </h2>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-12023">
            <InfoIcon size={16} data-id="element-12024" />
          </button>
        </div>
        <p className="text-sm text-gray-600 mb-6" data-id="element-12025">
          Rabbit Gateway's estimate of your Visa frauds and disputes. Aim to
          keep your VAMP ratio under 0.5%.{' '}
          <a href="#" className="text-blue-600 hover:text-blue-700 underline" data-id="element-12026">
            Learn more
          </a>{' '}
          about how to keep your disputes and fraud low.
        </p>

        <div className="bg-white border border-gray-200 rounded-lg p-8" data-id="element-12027">
          <p className="text-center text-gray-500" data-id="element-12028">No past history found.</p>
        </div>
      </div>

      {/* Resources */}
      <div data-id="element-12029">
        <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-12030">Resources</h2>
        <div className="flex flex-wrap gap-4" data-id="element-12031">
          <a href="#" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-12032">
            <ExternalLinkIcon size={14} data-id="element-12033" />
            Program overview
          </a>
          <a href="#" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-12034">
            <ExternalLinkIcon size={14} data-id="element-12035" />
            Preventing fraud and disputes
          </a>
          <a href="#" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-12036">
            <ExternalLinkIcon size={14} data-id="element-12037" />
            Preventing card testing
          </a>
        </div>
      </div>
    </div>;
}